export const SESSION_TYPE_BUMBLEBEE_STATUS = "bumblebee_status" as const;

export interface BumblebeeSessionListItem {
	session_id: string;
	campaign_id: string;
	session_type: typeof SESSION_TYPE_BUMBLEBEE_STATUS;
	display_title: string;
	campaign_name?: string | null;
	is_read_only: boolean;
	can_delete: boolean;
	created_at: string;
	updated_at: string;
	message_count: number;
	has_unread?: boolean;
	unread_count?: number;
}

export interface ListBumblebeeSessionsSuccessData {
	success: boolean;
	sessions: BumblebeeSessionListItem[];
	count: number;
}

export interface GetBumblebeeMessagesSuccessData {
	success: boolean;
	session_id: string;
	messages: BumblebeeChatMessage[];
	count: number;
}

export interface BumblebeeChatMessage {
	role: string;
	content: string;
	type: string;
	meta?: Record<string, unknown>;
	ts: string;
}

export interface MarkBumblebeeSessionReadSuccessData {
	success: boolean;
	session_id: string;
	has_unread: boolean;
}

export interface UpdateBumblebeeTitleSuccessData {
	success: boolean;
	session_id: string;
	display_title: string;
}
